import styled from 'styled-components';

/**
 * A red text action - Mark all as read, See all. Worn by the dropdown and the
 * page alike. Not `TextButton`, which stretches to the full width of its row
 * and so cannot sit beside a title.
 */
export const TextAction = styled.button`
  flex: none;
  padding: 4px 0;
  border: 0;
  background: none;
  font: inherit;
  font-size: 13px;
  line-height: 18px;
  font-weight: 700;
  color: ${({ theme }) => theme.primary};
  cursor: pointer;
  white-space: nowrap;

  &:disabled {
    opacity: 0.5;
    cursor: default;
  }

  &:hover:not(:disabled) {
    text-decoration: underline;
  }
`;
